<template>
  <div id="main">
    <v-carousel></v-carousel>
    <system-show></system-show>
    <!-- <v-product></v-product> -->
    <v-about></v-about>
    <v-company-contact></v-company-contact>
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  name: "main",
  data() {
    return {};
  }
};
</script>







// WEBPACK FOOTER //
// src/components/main.vue